import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import "./sa-dashboard.scss";

/**
 * SAStatCard — KPI card for the Super Admin dashboard.
 * Reuses the db-kpi-card patterns from the main Dashboard.
 */
const SAStatCard = ({ title, value, change, changeType, icon: Icon, iconClass = "", suffix, onClick }) => {
  const isPositive = changeType === "positive";

  return (
    <div className="sa-kpi-card" onClick={onClick} role={onClick ? "button" : undefined}>
      <div className="sa-kpi-inner">
        <div className="sa-kpi-info">
          <span className="sa-kpi-label">{title}</span>
          <div className="sa-kpi-value">
            {value}
            {suffix && <span className="sa-kpi-suffix">{suffix}</span>}
          </div>
          {change && (
            <div className={`sa-kpi-trend ${isPositive ? "positive" : "negative"}`}>
              {isPositive ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
              <span>{change}</span>
            </div>
          )}
        </div>
        {Icon && <div className={`sa-kpi-icon ${iconClass}`}><Icon size={20} /></div>}
      </div>
    </div>
  );
};

export default SAStatCard;
